import React from "react";
import { CountryDropdown } from "react-country-region-selector";
import PropTypes from "prop-types";
import "./index.scss";

const SelectCountry = ({
  label,
  value,
  onChange,
  disabled,
  error,
  errorMessage,
}) => {
  return (
    <div className="country-select">
      <label className="label">{label}</label>
      <CountryDropdown
        value={value}
        onChange={onChange}
        className={`select ${error ? "-error" : ""}`}
        disabled={disabled}
        label="Country"
        id="country"
        valueType="short"
        labelType="full"
      />
      {error && (
        <label htmlFor="country" className="error">
          {errorMessage}
        </label>
      )}
    </div>
  );
};

SelectCountry.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string.isRequired,
};

SelectCountry.defaultProps = {
  disabled: false,
  error: false,
};

export default SelectCountry;
